import { ABAS_CONFIGURAVEIS_DA_FICHA, type AbaConfiguravel, type ConfiguracaoDePacientes } from "@bookdental/schemas";
import { Toggle } from "@/components/settings/primitives";

export const ROTULO_DA_ABA: Record<AbaConfiguravel, string> = {
  anamnese: "Anamnese",
  odontograma: "Odontograma",
  tratamentos: "Tratamentos",
  consultas: "Consultas",
  proteses: "Próteses",
  arquivos: "Arquivos",
  financeiro: "Financeiro",
  historico: "Histórico",
};

/** Abas da ficha que a clínica usa. Início e Dados ficam sempre. */
export function SecaoFicha({ valor, onChange }: { valor: ConfiguracaoDePacientes; onChange: (v: ConfiguracaoDePacientes) => void }) {
  const ocultas = valor.ficha.abasOcultas;
  const alternar = (aba: AbaConfiguravel, visivel: boolean) =>
    onChange({
      ...valor,
      ficha: { abasOcultas: ABAS_CONFIGURAVEIS_DA_FICHA.filter((a) => (a === aba ? !visivel : ocultas.includes(a))) },
    });

  return (
    <div className="space-y-3">
      <p className="text-[12.5px] leading-relaxed text-zinc-500 dark:text-muted-foreground">
        Desligue as abas que a clínica não usa. Início e Dados aparecem sempre. Esconder não apaga nada: ligar de novo traz a aba de volta como estava.
        Abas que dependem de permissão ou de recurso continuam seguindo essas regras.
      </p>
      <div className="grid gap-2 sm:grid-cols-2">
        {ABAS_CONFIGURAVEIS_DA_FICHA.map((aba) => (
          <Toggle key={aba} label={ROTULO_DA_ABA[aba]} checked={!ocultas.includes(aba)} onChange={(v) => alternar(aba, v)} />
        ))}
      </div>
    </div>
  );
}
